import { /*LOCALE_ID, */ NgModule } from '@angular/core';
import { environment } from '../environments/environment';
// import { registerLocaleData } from '@angular/common';
// import localeIt from '@angular/common/locales/it';
//
// registerLocaleData(localeIt, 'it');

// modules (angular)
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// modules (third-party)
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';
import { QRCodeModule } from 'angular2-qrcode';

// modules
import { AppRoutingModule } from './app-routing.module';
import { BlocksModule } from './modules/blocks/blocks.module';
import { FooterModule } from './modules/footer/footer.module';
import { HeaderModule } from './modules/header/header.module';
import { MobileModule } from './modules/mobile/mobile.module';
import { SharedModule } from './shared/shared.module';
import { WidgetsModule } from './modules/widgets/widgets.module';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';

// components
import { AppComponent } from './app.component';
import { RootComponent } from './components/root/root.component';

// pages
import { PageHomeOneComponent } from './pages/page-home-one/page-home-one.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PageHomeTwoComponent } from './pages/page-home-two/page-home-two.component';
import { LoginComponent } from './pages/login/login/login.component';

// services
import { AuthService } from 'src/app/shared/services/auth.service';

@NgModule({
  declarations: [
    // components
    AppComponent,
    RootComponent,
    // pages
    PageHomeOneComponent,
    PageNotFoundComponent,
    PageHomeTwoComponent,
    LoginComponent
  ],
  imports: [
    // modules (angular)
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    // modules (third-party)
    CarouselModule,
    QRCodeModule,
    ToastrModule.forRoot(),
    // modules
    AppRoutingModule,
    BlocksModule,
    FooterModule,
    HeaderModule,
    MobileModule,
    SharedModule,
    WidgetsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule
  ],
  providers: [
    AuthService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
